import React from 'react';
import { useAuthContext } from '../context/AuthContext';

const SessionInfo = () => {
  const { user } = useAuthContext();
  
  const getTimeRemaining = () => {
    const sessionTimestamp = localStorage.getItem('sessionTimestamp');
    const lastActivity = localStorage.getItem('lastActivity');
    
    if (!sessionTimestamp) return 'No hay sesión activa';
    
    const now = Date.now();
    const sessionAge = now - parseInt(sessionTimestamp);
    const timeSinceLastActivity = now - parseInt(lastActivity || sessionTimestamp);
    
    const sessionTimeRemaining = (8 * 60 * 60 * 1000) - sessionAge; // 8 horas
    const activityTimeRemaining = (2 * 60 * 60 * 1000) - timeSinceLastActivity; // 2 horas
    
    const minTime = Math.min(sessionTimeRemaining, activityTimeRemaining);
    
    if (minTime <= 0) return 'Sesión expirada';
    
    const hours = Math.floor(minTime / (1000 * 60 * 60));
    const minutes = Math.floor((minTime % (1000 * 60 * 60)) / (1000 * 60));
    
    return `${hours}h ${minutes}m restantes`;
  };

  if (!user) return null;

  return (
    <div className="hidden lg:block fixed bottom-4 right-4 bg-white/90 backdrop-blur-sm border border-gray-200 rounded-lg p-3 shadow-sm text-xs text-gray-600">
      <div>Sesión: {user.email}</div>
      <div>Tiempo: {getTimeRemaining()}</div>
    </div>
  );
};

export default SessionInfo;